export default "__VITE_ASSET__DchhqEDH__"